module.exports = "/assets/data/444415adf473be383fdb8470fe2caf26-HU10.data.json";